<template>
  <q-page class="">
    <div class="q-pa-md q-gutter-sm flex">
      <q-breadcrumbs>
        <q-breadcrumbs-el label="dashboard" icon="dashboard" to="/app/" />
        <q-breadcrumbs-el :label="labelCurrent" icon="build" :to="linkCurrent" />
      </q-breadcrumbs>
      <q-btn
        target="_blank"
        color="blue"
        label="Accéder à la séance"
        class="q-ml-lg"
        :to="{name: 'visu', params: {idSeance: currentSeanceId}}"
        />
    </div>
    <div class="q-pa-md q-gutter-sm" v-if="currentSeance.is_demo">
      <q-banner class="text-white bg-red">
        <template v-slot:avatar>
          <q-icon name="warning" color="white" />
        </template>
        Cette séance est une séance de démonstration.
      </q-banner>
    </div>
    <section class="row justify-around items-start">
      <div class="q-pa-md row">
        <q-card class="my-card q-mb-md">
          <q-toolbar class="text-primary">
            <q-toolbar-title cypress="title">
              Boissons
            </q-toolbar-title>
            <q-btn 
              color="secondary" 
              icon-right="add" 
              label="Nouvelle boisson" 
              @click="addNewDrink()"
              :disabled="disabledActions"/>
          </q-toolbar>
          <q-separator />

          <q-markup-table>
            <thead>
              <tr>
                <th class="text-left">Nom</th>
                <th class="text-right">Prix départ</th>
                <th class="text-right">Prix en cours</th>
                <th class="text-right">Prix min</th>
                <th class="text-right">Prix max</th>
                <th class="text-right">Modification</th>
                <th class="text-right">Suppression</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="boissons" v-for="boisson in boissons" :key="boisson.id" cypress="drinkList">
                <td class="text-left text-capitalize text-weight-medium">{{boisson.name}}</td>
                <td class="text-right">{{boisson.start_price}} €</td>
                <td class="text-right">{{boisson.current_price}} €</td>
                <td class="text-right">{{boisson.lower_price}} €</td>
                <td class="text-right">{{boisson.higher_price}} €</td>
                <td class="text-right">
                  <q-btn 
                    color="primary" 
                    icon-right="create" 
                    label="" 
                    @click="updateDrink(boisson.id)"
                    :disabled="disabledActions"/>
                </td>
                <td class="text-right">
                  <q-btn 
                    color="red" 
                    icon-right="clear" 
                    label=""
                    :disabled="disabledActions"
                    @click="showDeleteDrink(boisson.id)" />
                </td>
              </tr>
            </tbody>
          </q-markup-table>
        </q-card>
        <div class="q-ml-md q-mb-md">
          <q-card>
            <q-toolbar class="text-primary">
              <q-toolbar-title>
                Paramètres généraux
              </q-toolbar-title>
            </q-toolbar>
            <q-separator />
            <div class="row justify-between q-pa-md">
              <q-toggle 
                left-label
                :value="specifyPaymentMethod"
                label="- Spécifier le moyen de paiement à la prise de commande"
                :disable="currentSeance.closed"
                @input="togglePaymentMethodRequirement"/>
            </div>
            <div class="row justify-center q-pa-md">
              <q-btn
                v-if="notStartedYet"
                color="primary"
                label="Démarrer la séance"
                :disabled="disabledStart"
                :title="titleStart"
                @click="scheduleSeancePopup = true; start = true;"/>
              <q-btn
                v-if="currentSeance.running"
                color="red"
                label="Clore la séance"
                :disabled="disabledStop"
                :title="titleStop"
                @click="scheduleSeancePopup = true; start = false;"/>
            </div>
          </q-card>
          <q-card class="q-mt-md ">
            <q-toolbar class="text-primary">
              <q-toolbar-title>
                Krachs
              </q-toolbar-title>
            </q-toolbar>
            <q-separator />
            <q-markup-table>
              <thead>
                <tr>
                  <th >Heure de début</th>
                  <th >Heure de fin</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="krachs" v-for="krach in krachs" :key="krach.id">
                  <td class="text-center">{{getDateFormated(krach.start_time)}}</td>
                  <td class="text-center">{{getDateFormated(krach.end_time)}}</td>
                </tr>
              </tbody>
            </q-markup-table>
            <div class="row justify-between q-pa-md">
              <q-btn
                color="primary"
                label="Lancer un krach"
                class="q-mr-lg"
                :disabled="disabledStartKrach"
                :title="titleStart"
                @click="scheduleKrachPopup = true; start = true;"/>
              <q-btn
                color="red"
                label="Arrêter"
                class="q-ml-lg"
                :disabled="disabledStopKrach"
                :title="titleStop"
                @click="scheduleKrachPopup = true; start = false;"/>
            </div>
          </q-card>
          <q-card class="q-mt-md q-pa-md row justify-center" v-if="currentSeance.closed">
            <q-btn
                color="green"
                label="Exporter"
                :disabled="!disabledStopKrach"
                :title="titleExport"
                @click="exportData"/>
          </q-card>
        </div>
        
      </div>
    </section>
    <DrinkDialog 
      :show="addDrink"
      :drink="drink"
      :update="update"
      @submit="onSubmit"
      @reset="onReset"
      @update="onUpdate"
      @close="addDrink = false"/>
    <DeleteDrinkDialog
      :show="delDrink"
      :drink="drink"
      @delete="deleteDrink"
      @cancel="cancelDelete"
      @close="cancelDelete"
      />
    <StartSeanceDialog
      :show="scheduleSeancePopup"
      :seance="currentSeance"
      :start="start"
      @cancel="scheduleSeancePopup = false"
      @stop="stopSeance(); scheduleSeancePopup = false"
      @start="startSeance(); scheduleSeancePopup = false"
      />
    <StartKrachDialog
      :show="scheduleKrachPopup"
      :start="start"
      @cancel="scheduleKrachPopup = false"
      @stop="stopKrach(); scheduleKrachPopup = false"
      @start="startKrach(); scheduleKrachPopup = false"
      />
  </q-page>
</template>

<style></style>

<script>
import ReconnectingEventSource from "reconnecting-eventsource";
import DrinkDialog from '~/components/DrinkDialog.vue';
import DeleteDrinkDialog from '~/components/DeleteDrinkDialog.vue';
import StartSeanceDialog from '~/components/StartSeanceDialog.vue';
import StartKrachDialog from '~/components/StartKrachDialog.vue';
import { createDrink, updateDrink, deleteDrink } from '~/services/drinks';
import { URL_EXPORT_DATA_BY_SEANCE_ID } from '~/services/urls';
import { getSeanceById, startSeance, stopSeance, toggleSeanceNeedPaymentMethod, startKrach, getKrachsBySeance, stopKrach, exportData } from '~/services/seances';
import { baseUrl, base_url_seances } from '~/variables';


export default {
  name: "Seance",
  components: {
    DrinkDialog,
    DeleteDrinkDialog,
    StartSeanceDialog,
    StartKrachDialog,
  },
  async created() {
    const respSeance = await getSeanceById(this.currentSeanceId);

    this.boissons = respSeance.data.drinks;
    this.currentSeance = respSeance.data;
    this.specifyPaymentMethod = this.currentSeance.need_payment_method
    const respKrach = await getKrachsBySeance(this.currentSeance);
    this.krachs = respKrach.data;
  },
  mounted() {
    this.setupStream();
  },
  data() {
    return {
      addDrink: false,
      delDrink: false,
      scheduleSeancePopup: false,
      scheduleKrachPopup: false,
      start: true,
      specifyPaymentMethod: false,
      currentSeanceId: this.$route.params.id,
      currentSeance: {},
      drink: {
        name: '',
        category: null,
        start_price: null,
        lower_price: null,
        higher_price: null,
      },
      krachs: [],
      boissons: [],
      update: false,
      dense: false,
      es: null
    }
  },
  destroyed () {
    this.es.close()
  },
  methods: {
    setupStream() {
      // Not a real URL, just using for demo purposes
      this.es = new ReconnectingEventSource(`${baseUrl}${base_url_seances}/${this.currentSeanceId}/events/`);
      this.es.addEventListener('krach_stop', event => {
        let data = JSON.parse(event.data);
        const indexToUpdate = this.krachs.findIndex(e => e.id === data.id);
        this.krachs[indexToUpdate].end_time = data.end_time
      }, false);
    },
    async onSubmit() {
      await this.createDrinkAPI(
        { 
          name: this.drink.name, 
          category_id: this.drink.category.id,
          start_price: this.drink.start_price,
          lower_price: this.drink.lower_price,
          higher_price: this.drink.higher_price,
          seance: this.currentSeanceId
        });
      this.addDrink = false;
      this.resetVars();
    },
    getDateFormated (date) {
      if (date) {
        const options = {hour: "numeric", minute: "numeric", second: "numeric"}
        return new Intl.DateTimeFormat("fr-FR", options).format(new Date(date))
      }
      return ''
    },
    onReset() {
      this.resetVars();
    },
    async onUpdate() {
      let drinkToUpdate = {...this.drink}
      drinkToUpdate.category_id = drinkToUpdate.category.id
      delete drinkToUpdate.category
      await this.updateDrinkAPI(drinkToUpdate);
      this.addDrink = false;
      this.update = false;
      this.resetVars();
    },
    resetVars() {
      this.drink = {}
      this.drink = {
        name: '',
        start_price: null,
        lower_price: null,
        higher_price: null,
        seance: this.currentSeance,
      };
    },
    addNewDrink() {
      this.resetVars();
      this.update = false;
      this.addDrink = true;
    },
    updateDrink(id) {
      let drinkToUpdate = this.boissons.filter(e => e.id === id)[0];
      this.drink = {...drinkToUpdate};
      this.update = true;
      this.addDrink = true;
    },
    showDeleteDrink(id) {
      let drinkToDelete = this.boissons.filter(e => e.id === id)[0];
      this.delDrink = true;
      this.drink = {...drinkToDelete}
    },
    async deleteDrink() {
      await this.deleteDrinkAPI(this.drink);
      this.delDrink = false;
      this.resetVars()
    },
    cancelDelete() {
      this.delDrink = false;
      this.resetVars()
    },
    async createDrinkAPI(drink) {
      const response =  await createDrink(drink);
      if (response.status == 201) {
        this.addDrinkMethod(response.data);
        this.$q.notify({
          color: 'green-4',
          textColor: 'white',
          icon: 'fas fa-check-circle',
          message: 'Élément ajouté',
          position: 'top-right'
        });
      }else {
        this.$q.notify({
          color: 'red-4',
          textColor: 'white',
          icon: 'fas fa-exclamation-circle',
          message: response.data.non_field_errorq,
          position: 'top-right'
        });
      }
      
    },
    async updateDrinkAPI(drink) {
      const response =  await updateDrink(drink);
      if (response.status === 200 ) {
        this.updateDrinkMethod(response.data);
        this.$q.notify({
          color: 'green-4',
          textColor: 'white',
          icon: 'fas fa-check-circle',
          message: 'Élément mis à jour',
          position: 'top-right'
        });
      } else {
        this.$q.notify({
          color: 'red-4',
          textColor: 'white',
          icon: 'fas fa-exclamation-circle',
          message: 'Impossible de mettre à jour la boisson, réessayer ou rechargez la page web',
          position: 'top-right'
        });
      }
    },
    async deleteDrinkAPI(drink) {
      const response = await deleteDrink(drink);
      if (response.status === 204) {
        this.deleteDrinkMethod(drink);
        this.$q.notify({
          color: 'green-4',
          textColor: 'white',
          icon: 'fas fa-check-circle',
          message: 'Élément supprimé',
          position: 'top-right'
        });
      }else {
        this.$q.notify({
          color: 'red-4',
          textColor: 'white',
          icon: 'fas fa-exclamation-circle',
          message: response.data.non_field_errorq,
          position: 'top-right'
        });
      }
      return response
    },
    async startSeance() {
      const resp = await startSeance(this.currentSeance)
      if (resp.status === 200) {
        this.currentSeance = resp.data;
        this.$q.notify({
          color: 'green-4',
          textColor: 'white',
          icon: 'fas fa-check-circle',
          message: 'La séance a démarré',
          position: 'top-right'
        });
      } else {
        this.$q.notify({
          color: 'red-4',
          textColor: 'white',
          icon: 'fas fa-exclamation-circle',
          message: "La séance n'a pas pu démarrer",
          position: 'top-right'
        });
      }
    },
    async stopSeance() {
      const resp = await stopSeance(this.currentSeance)
      if (resp.status === 200) {
        this.currentSeance = resp.data;
        this.$q.notify({
          color: 'green-4',
          textColor: 'white',
          icon: 'fas fa-check-circle',
          message: "La séance s'est arrêtée",
          position: 'top-right'
        });
      } else {
        this.$q.notify({
          color: 'red-4',
          textColor: 'white',
          icon: 'fas fa-exclamation-circle',
          message: "La séance n'a pas pu s'arrêter",
          position: 'top-right'
        });
      }
    },
    async togglePaymentMethodRequirement() {
      const resp = await toggleSeanceNeedPaymentMethod(this.currentSeance)
      if (resp.status === 200) {
        this.specifyPaymentMethod = resp.data.need_payment_method
      } else {
        this.$q.notify({
          color: 'red-4',
          textColor: 'white',
          icon: 'fas fa-exclamation-circle',
          message: "Impossible de mettre à jour",
          position: 'top-right'
        });
      }
    },
    exportData() {
      window.open(`/api${URL_EXPORT_DATA_BY_SEANCE_ID(this.currentSeanceId)}`, "_blank");
    },
    addDrinkMethod(drink) {
      this.boissons.push(drink);
    },
    updateDrinkMethod(drink) {
      let indexToUpdate = this.boissons.findIndex(e => e.id === drink.id)
      this.boissons[indexToUpdate] = drink;
    },
    deleteDrinkMethod(drink) {
      let indexToDelete = this.boissons.findIndex(e => e.id === drink.id)
      this.boissons.splice(indexToDelete, 1);
    },
    emptyDrinksMethod() {
      this.boissons = [];
    },
    async startKrach() {
      const resp = await startKrach(this.currentSeance)
      if (resp.status === 201) {
        this.krachs.push(resp.data);
        this.$q.notify({
          color: 'green-4',
          textColor: 'white',
          icon: 'fas fa-check-circle',
          message: 'Le krach s\'est lancé',
          position: 'top-right'
        });
      } else {
        this.$q.notify({
          color: 'red-4',
          textColor: 'white',
          icon: 'fas fa-exclamation-circle',
          message: "Le krach ne s\'est pas lancé",
          position: 'top-right'
        });
      }
    },
    async stopKrach() {
      const resp = await stopKrach(this.currentKrach)
      let indexToUpdate = this.krachs.findIndex(e => e.id === this.currentKrach.id)
      this.$set(this.krachs, indexToUpdate, resp.data)
      this.krachs[indexToUpdate] = resp.data;
      if (resp.status === 200) {
        this.$q.notify({
          color: 'green-4',
          textColor: 'white',
          icon: 'fas fa-check-circle',
          message: "Le krach s'est arrêté",
          position: 'top-right'
        });
      } else {
        this.$q.notify({
          color: 'red-4',
          textColor: 'white',
          icon: 'fas fa-exclamation-circle',
          message: "Le krach n'a pas pu s'arrêter",
          position: 'top-right'
        });
      }
    },
  },
  computed: {
    countDrinks() {
      if(this.boissons) 
        return this.boissons.length;
      return 0
    },
    linkCurrent() {
      return `/app/seance/${this.currentSeanceId}`;
    },
    labelCurrent() {
      if (this.currentSeance.is_demo) {
        return `Seance de démonstration ${this.currentSeance.code_acces}`;
      }
      return `Seance ${this.currentSeance.code_acces}`;
    },
    disabledActions() {
      return this.currentSeance.closed;
    },
    disabledStart() {
      return this.currentSeance.running || !this.currentSeance.opened || this.currentSeance.drinks.length === 0 || this.disabledActions;
    },
    disabledStop() {
      return !this.currentSeance.running || !this.currentSeance.opened || this.disabledActions;
    },
    disabledStartKrach() {
      return this.disabledStop;
    },
    disabledStopKrach() {
      let disabled = this.krachs.filter(e => !e.end_time)
          .map(() => false)
          .reduce( (accumulator, newValue) => accumulator && newValue , true);
      return disabled || this.disabledActions;
    },
    notStartedYet() {
      return !this.currentSeance.closed && !this.currentSeance.running
    },
    titleStart() {
      let string = '';
      if (this.disabledStart) {
        if (this.currentSeance.closed) {
          string = "La séance est déjà terminée";
        } else if (this.currentSeance.running) {
          string = "La séance a déjà commencé";
        } else if (this.currentSeance.drinks && this.currentSeance.drinks.length === 0) {
          string = "Veuillez ajouter des boissons";
        }
      } else {
        string = "Démarrer la séance";
      }    
      return string;
    },
    titleStop() {
      let string = '';
      if (this.disabledStop) {
        if (this.currentSeance.closed) {
          string = "La séance est déjà terminée";
        } else {
          string = "La séance n'a pas encore commencé";
        }
      } else {
        string = "Arrêter la séance";
      }
      return string;
    },
    titleExport(){
       return this.currentSeance.closed ? 'Exporter' : "La séance n'est pas encore terminée"; 
    },
    currentKrach() {
      let krach = this.krachs.filter(e => !e.end_time);
      if(krach.length > 1) {
        // stops the last launched krach, maybe it's not the best decision, but it works
        krach = krach[krach.length-1]
      } else {
        krach = krach[0];
      }
      return krach;
    }
  },
};
</script>
